import Common from "./common.js";
import "../../scss/v5/list.scss";
import ExpandableMovie from "./components/ExpandableMovie.js";

Common.initPage(async () => {
  const headerHeight = document.querySelector("header#header")?.offsetHeight || 0;
  document.querySelectorAll(".item-list.movie-list > li > a").forEach((item) => {
    ExpandableMovie(item, { scrollOffset: headerHeight }).render();
  });
});
